// ============================================================================
// Entity: Users
// Key: users
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	getCustomPagesListQueryKey,
	getPauseReasonsListQueryKey,
	getQueuesListQueryKey,
	getRolesListQueryKey,
	getSkillGroupsListQueryKey,
	getSkillsListQueryKey,
	getTeamsListQueryKey,
	getTemplatesListQueryKey,
	getUsersClientGetCustompagesQueryKey,
	getUsersClientGetCustompagesQueryOptions,
	getUsersDetailQueryKey,
	getUsersDetailQueryOptions,
	getUsersListQueryKey,
	getUsersListQueryOptions,
	getUsersRelationsCustomPagesAssignedQueryKey,
	getUsersRelationsCustomPagesAssignedQueryOptions,
	getUsersRelationsCustomPagesAvailableQueryKey,
	getUsersRelationsCustomPagesAvailableQueryOptions,
	getUsersRelationsPauseReasonsAssignedQueryKey,
	getUsersRelationsPauseReasonsAssignedQueryOptions,
	getUsersRelationsPauseReasonsAvailableQueryKey,
	getUsersRelationsPauseReasonsAvailableQueryOptions,
	getUsersRelationsQueuesAssignedQueryKey,
	getUsersRelationsQueuesAssignedQueryOptions,
	getUsersRelationsQueuesAvailableQueryKey,
	getUsersRelationsQueuesAvailableQueryOptions,
	getUsersRelationsRolesAssignedQueryKey,
	getUsersRelationsRolesAssignedQueryOptions,
	getUsersRelationsRolesAvailableQueryKey,
	getUsersRelationsRolesAvailableQueryOptions,
	getUsersRelationsSkillGroupsAssignedQueryKey,
	getUsersRelationsSkillGroupsAssignedQueryOptions,
	getUsersRelationsSkillGroupsAvailableQueryKey,
	getUsersRelationsSkillGroupsAvailableQueryOptions,
	getUsersRelationsSkillsAssignedQueryKey,
	getUsersRelationsSkillsAssignedQueryOptions,
	getUsersRelationsSkillsAvailableQueryKey,
	getUsersRelationsSkillsAvailableQueryOptions,
	getUsersRelationsTeamsAssignedQueryKey,
	getUsersRelationsTeamsAssignedQueryOptions,
	getUsersRelationsTeamsAvailableQueryKey,
	getUsersRelationsTeamsAvailableQueryOptions,
	getUsersSettingsContactLoadQueryKey,
	getUsersSettingsContactLoadQueryOptions,
	getUsersSettingsGeneralLoadQueryKey,
	getUsersSettingsGeneralLoadQueryOptions,
	getUsersSettingsLoginLoadQueryKey,
	getUsersSettingsLoginLoadQueryOptions,
	getUsersSettingsPhoneLoadQueryKey,
	getUsersSettingsPhoneLoadQueryOptions,
	getUsersSettingsRecordingLoadQueryKey,
	getUsersSettingsRecordingLoadQueryOptions,
	getUsersSettingsSetclipLoadQueryKey,
	getUsersSettingsSetclipLoadQueryOptions,
	getUsersSettingsSubstitutionLoadQueryKey,
	getUsersSettingsSubstitutionLoadQueryOptions,
	usersRelationsCustomPagesAssign,
	usersRelationsCustomPagesUnassign,
	usersRelationsPauseReasonsAssign,
	usersRelationsPauseReasonsUnassign,
	usersRelationsQueuesAssign,
	usersRelationsQueuesUnassign,
	usersRelationsQueuesUpdate,
	usersRelationsRolesAssign,
	usersRelationsRolesUnassign,
	usersRelationsSkillGroupsAssign,
	usersRelationsSkillGroupsUnassign,
	usersRelationsSkillGroupsUpdate,
	usersRelationsSkillsAssign,
	usersRelationsSkillsUnassign,
	usersRelationsSkillsUpdate,
	usersRelationsTeamsAssign,
	usersRelationsTeamsUnassign,
	usersRelationsTeamsUpdate,
	usersRelationsTemplatesUpdate,
	usersSettingsContactReset,
	usersSettingsContactUpdate,
	usersSettingsGeneralReset,
	usersSettingsGeneralUpdate,
	usersSettingsLoginReset,
	usersSettingsLoginUpdate,
	usersSettingsPhoneReset,
	usersSettingsPhoneUpdate,
	usersSettingsRecordingReset,
	usersSettingsRecordingUpdate,
	usersSettingsSetclipReset,
	usersSettingsSetclipUpdate,
	usersSettingsSubstitutionReset,
	usersSettingsSubstitutionUpdate,
} from '../api/backstage'
// #region Imports
import type {
	ContactSettingsDto,
	CreateOrUpdateContactSettingsRequest,
	CreateOrUpdateGeneralSettingsRequest,
	CreateOrUpdateLoginSettingsRequest,
	CreateOrUpdatePhoneSettingsRequest,
	CreateOrUpdateRecordingSettingsRequest,
	CreateOrUpdateSetClipSettingsRequest,
	CreateOrUpdateSubstitutionSettingsRequest,
	CustomPageDto,
	GeneralSettingsDto,
	LoginSettingsDto,
	PagedResultOfCustomPageDto,
	PagedResultOfPauseReasonSummary,
	PagedResultOfQueueSummary,
	PagedResultOfRoleSummary,
	PagedResultOfSkillGroupSummary,
	PagedResultOfSkillSummary,
	PagedResultOfTeamSummary,
	PagedResultOfTeamUserDto,
	PagedResultOfUserCustomPageDto,
	PagedResultOfUserDto,
	PagedResultOfUserPauseReasonDto,
	PagedResultOfUserQueueDto,
	PagedResultOfUserRoleDto,
	PagedResultOfUserSkillDto,
	PagedResultOfUserSkillGroupDto,
	PhoneSettingsDto,
	RecordingSettingsDto,
	SetClipSettingsDto,
	SubstitutionSettingsDto,
	TeamUserDto,
	UpdateTeamUserRequest,
	UpdateUserQueueRequest,
	UpdateUserSkillGroupRequest,
	UpdateUserSkillRequest,
	UserCustomPageDto,
	UserDetails,
	UserPauseReasonDto,
	UserQueueDto,
	UserRoleDto,
	UserSkillDto,
	UserSkillGroupDto,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const usersEntityEndpoints = {
	detail: defineQueryEndpoint<UserDetails, { userId: number }, undefined>({
		key: 'users.detail',
		method: 'GET',
		path: '/admin/users/{userId}',
		pathParams: ['userId'] as const,
		queryKey: (args) => getUsersDetailQueryKey(args?.pathParams?.userId),
		queryOptions: (args) =>
			getUsersDetailQueryOptions(args?.pathParams?.userId),
	}),
	list: defineQueryEndpoint<PagedResultOfUserDto, undefined, ListQueryParams>({
		key: 'users.list',
		method: 'GET',
		path: '/admin/users',
		queryKey: (args) => getUsersListQueryKey(args?.queryParams),
		queryOptions: (args) => getUsersListQueryOptions(args?.queryParams),
	}),
} as const
// #endregion

// #region Relations
// #region Relation: CustomPages
// Target Entity: customPages
const usersCustomPagesRelation = {
	key: 'customPages',
	targetEntity: 'customPages',
	endpoints: {
		assign: defineMutationEndpoint<
			UserCustomPageDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.customPages.assign',
			method: 'POST',
			path: '/admin/users/{userId}/custompages',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsCustomPagesAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsCustomPagesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsCustomPagesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getCustomPagesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfUserCustomPageDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.customPages.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/custompages',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsCustomPagesAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsCustomPagesAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfCustomPageDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.customPages.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-custompages',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsCustomPagesAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsCustomPagesAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.customPages.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/custompages',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					usersRelationsCustomPagesUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsCustomPagesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsCustomPagesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getCustomPagesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: PauseReasons
// Target Entity: pauseReasons
const usersPauseReasonsRelation = {
	key: 'pauseReasons',
	targetEntity: 'pauseReasons',
	endpoints: {
		assign: defineMutationEndpoint<
			UserPauseReasonDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.pauseReasons.assign',
			method: 'POST',
			path: '/admin/users/{userId}/pausereasons',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					usersRelationsPauseReasonsAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsPauseReasonsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsPauseReasonsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getPauseReasonsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfUserPauseReasonDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.pauseReasons.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/pausereasons',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsPauseReasonsAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsPauseReasonsAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfPauseReasonSummary,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.pauseReasons.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-pausereasons',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsPauseReasonsAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsPauseReasonsAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.pauseReasons.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/pausereasons',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					usersRelationsPauseReasonsUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsPauseReasonsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsPauseReasonsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getPauseReasonsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Queues
// Target Entity: queues
const usersQueuesRelation = {
	key: 'queues',
	targetEntity: 'queues',
	endpoints: {
		assign: defineMutationEndpoint<
			UserQueueDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.queues.assign',
			method: 'POST',
			path: '/admin/users/{userId}/queues',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsQueuesAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfUserQueueDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.queues.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/queues',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsQueuesAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsQueuesAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfQueueSummary,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.queues.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-queues',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsQueuesAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsQueuesAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.queues.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/queues',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsQueuesUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
		update: defineMutationEndpoint<
			UserQueueDto,
			UpdateUserQueueRequest,
			{ userId: number; mappingId: number }
		>({
			key: 'users.relations.queues.update',
			method: 'PUT',
			path: '/admin/users/{userId}/queues/{mappingId}',
			pathParams: ['userId', 'mappingId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					mappingId: number | string | null | undefined
					data: UpdateUserQueueRequest
				}) =>
					usersRelationsQueuesUpdate(
						variables.userId,
						variables.mappingId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsQueuesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsQueuesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getQueuesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Roles
// Target Entity: roles
const usersRolesRelation = {
	key: 'roles',
	targetEntity: 'roles',
	endpoints: {
		assign: defineMutationEndpoint<
			UserRoleDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.roles.assign',
			method: 'POST',
			path: '/admin/users/{userId}/roles',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsRolesAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsRolesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsRolesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getRolesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfUserRoleDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.roles.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/roles',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsRolesAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsRolesAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfRoleSummary,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.roles.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-roles',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsRolesAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsRolesAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.roles.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/roles',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsRolesUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsRolesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsRolesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getRolesListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: SkillGroups
// Target Entity: skillGroups
const usersSkillGroupsRelation = {
	key: 'skillGroups',
	targetEntity: 'skillGroups',
	endpoints: {
		assign: defineMutationEndpoint<
			UserSkillGroupDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.skillGroups.assign',
			method: 'POST',
			path: '/admin/users/{userId}/skillgroups',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsSkillGroupsAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsSkillGroupsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsSkillGroupsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getSkillGroupsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfUserSkillGroupDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.skillGroups.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/skillgroups',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsSkillGroupsAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsSkillGroupsAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfSkillGroupSummary,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.skillGroups.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-skillgroups',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsSkillGroupsAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsSkillGroupsAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.skillGroups.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/skillgroups',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					usersRelationsSkillGroupsUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsSkillGroupsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsSkillGroupsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getSkillGroupsListQueryKey(),
			],
		}),
		update: defineMutationEndpoint<
			UserSkillGroupDto,
			UpdateUserSkillGroupRequest,
			{ userId: number; mappingId: number }
		>({
			key: 'users.relations.skillGroups.update',
			method: 'PUT',
			path: '/admin/users/{userId}/skillgroups/{mappingId}',
			pathParams: ['userId', 'mappingId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					mappingId: number | string | null | undefined
					data: UpdateUserSkillGroupRequest
				}) =>
					usersRelationsSkillGroupsUpdate(
						variables.userId,
						variables.mappingId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsSkillGroupsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsSkillGroupsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getSkillGroupsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Skills
// Target Entity: skills
const usersSkillsRelation = {
	key: 'skills',
	targetEntity: 'skills',
	endpoints: {
		assign: defineMutationEndpoint<
			UserSkillDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.skills.assign',
			method: 'POST',
			path: '/admin/users/{userId}/skills',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsSkillsAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfUserSkillDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.skills.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/skills',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsSkillsAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsSkillsAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfSkillSummary,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.skills.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-skills',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsSkillsAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsSkillsAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.skills.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/skills',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsSkillsUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
		update: defineMutationEndpoint<
			UserSkillDto,
			UpdateUserSkillRequest,
			{ userId: number; mappingId: number }
		>({
			key: 'users.relations.skills.update',
			method: 'PUT',
			path: '/admin/users/{userId}/skills/{mappingId}',
			pathParams: ['userId', 'mappingId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					mappingId: number | string | null | undefined
					data: UpdateUserSkillRequest
				}) =>
					usersRelationsSkillsUpdate(
						variables.userId,
						variables.mappingId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsSkillsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsSkillsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getSkillsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Teams
// Target Entity: teams
const usersTeamsRelation = {
	key: 'teams',
	targetEntity: 'teams',
	endpoints: {
		assign: defineMutationEndpoint<
			TeamUserDto[],
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.teams.assign',
			method: 'POST',
			path: '/admin/users/{userId}/teams',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsTeamsAssign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsTeamsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsTeamsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getTeamsListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfTeamUserDto,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.teams.assigned',
			method: 'GET',
			path: '/admin/users/{userId}/teams',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsTeamsAssignedQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsTeamsAssignedQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfTeamSummary,
			{ userId: number },
			ListQueryParams
		>({
			key: 'users.relations.teams.available',
			method: 'GET',
			path: '/admin/users/{userId}/assignable-teams',
			pathParams: ['userId'] as const,
			queryKey: (args) =>
				getUsersRelationsTeamsAvailableQueryKey(
					args?.pathParams?.userId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getUsersRelationsTeamsAvailableQueryOptions(
					args?.pathParams?.userId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ userId: number }
		>({
			key: 'users.relations.teams.unassign',
			method: 'DELETE',
			path: '/admin/users/{userId}/teams',
			pathParams: ['userId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					data: (number | string)[]
				}) => usersRelationsTeamsUnassign(variables.userId, variables.data),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsTeamsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsTeamsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getTeamsListQueryKey(),
			],
		}),
		update: defineMutationEndpoint<
			TeamUserDto,
			UpdateTeamUserRequest,
			{ userId: number; mappingId: number }
		>({
			key: 'users.relations.teams.update',
			method: 'PUT',
			path: '/admin/users/{userId}/teams/{mappingId}',
			pathParams: ['userId', 'mappingId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					mappingId: number | string | null | undefined
					data: UpdateTeamUserRequest
				}) =>
					usersRelationsTeamsUpdate(
						variables.userId,
						variables.mappingId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getUsersRelationsTeamsAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getUsersRelationsTeamsAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getUsersListQueryKey(),
				(_context) => getTeamsListQueryKey(),
			],
		}),
	},
} as const
// #endregion

// #region Relation: Templates
// Target Entity: templates
const usersTemplatesRelation = {
	key: 'templates',
	targetEntity: 'templates',
	endpoints: {
		update: defineMutationEndpoint<
			void,
			undefined,
			{ userId: number; templateId: number }
		>({
			key: 'users.relations.templates.update',
			method: 'PUT',
			path: '/admin/users/{userId}/templates/{templateId}',
			pathParams: ['userId', 'templateId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					userId: number | string | null | undefined
					templateId: number | string | null | undefined
				}) =>
					usersRelationsTemplatesUpdate(variables.userId, variables.templateId),
			}),
			invalidates: [
				(_context) => getUsersListQueryKey(),
				(_context) => getTemplatesListQueryKey(),
			],
		}),
	},
} as const
// #endregion
// #endregion

// #region Settings
const usersSettings = {
	key: 'settings',
	defaultSection: 'contact',
	sections: {
		contact: {
			key: 'contact',
			endpoints: {
				load: defineQueryEndpoint<
					ContactSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.contact.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/contact',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsContactLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsContactLoadQueryOptions(args?.pathParams?.userId),
				}),
				reset: defineMutationEndpoint<
					ContactSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.contact.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/contact',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsContactReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsContactLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					ContactSettingsDto,
					CreateOrUpdateContactSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.contact.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/contact',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdateContactSettingsRequest
						}) => usersSettingsContactUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsContactLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		general: {
			key: 'general',
			endpoints: {
				load: defineQueryEndpoint<
					GeneralSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.general.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/general',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsGeneralLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsGeneralLoadQueryOptions(args?.pathParams?.userId),
				}),
				reset: defineMutationEndpoint<
					GeneralSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.general.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/general',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsGeneralReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsGeneralLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					GeneralSettingsDto,
					CreateOrUpdateGeneralSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.general.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/general',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdateGeneralSettingsRequest
						}) => usersSettingsGeneralUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsGeneralLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		login: {
			key: 'login',
			endpoints: {
				load: defineQueryEndpoint<
					LoginSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.login.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/login',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsLoginLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsLoginLoadQueryOptions(args?.pathParams?.userId),
				}),
				reset: defineMutationEndpoint<
					LoginSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.login.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/login',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsLoginReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsLoginLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					LoginSettingsDto,
					CreateOrUpdateLoginSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.login.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/login',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdateLoginSettingsRequest
						}) => usersSettingsLoginUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsLoginLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		phone: {
			key: 'phone',
			endpoints: {
				load: defineQueryEndpoint<
					PhoneSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.phone.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/phone',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsPhoneLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsPhoneLoadQueryOptions(args?.pathParams?.userId),
				}),
				reset: defineMutationEndpoint<
					PhoneSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.phone.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/phone',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsPhoneReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsPhoneLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					PhoneSettingsDto,
					CreateOrUpdatePhoneSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.phone.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/phone',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdatePhoneSettingsRequest
						}) => usersSettingsPhoneUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsPhoneLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		recording: {
			key: 'recording',
			endpoints: {
				load: defineQueryEndpoint<
					RecordingSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.recording.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/recording',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsRecordingLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsRecordingLoadQueryOptions(args?.pathParams?.userId),
				}),
				reset: defineMutationEndpoint<
					RecordingSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.recording.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/recording',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsRecordingReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsRecordingLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					RecordingSettingsDto,
					CreateOrUpdateRecordingSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.recording.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/recording',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdateRecordingSettingsRequest
						}) =>
							usersSettingsRecordingUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsRecordingLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		setclip: {
			key: 'setclip',
			endpoints: {
				load: defineQueryEndpoint<
					SetClipSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.setclip.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/setclip',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsSetclipLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsSetclipLoadQueryOptions(args?.pathParams?.userId),
				}),
				reset: defineMutationEndpoint<
					SetClipSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.setclip.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/setclip',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsSetclipReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsSetclipLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					SetClipSettingsDto,
					CreateOrUpdateSetClipSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.setclip.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/setclip',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdateSetClipSettingsRequest
						}) => usersSettingsSetclipUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsSetclipLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
		substitution: {
			key: 'substitution',
			endpoints: {
				load: defineQueryEndpoint<
					SubstitutionSettingsDto,
					{ userId: number },
					undefined
				>({
					key: 'users.settings.substitution.load',
					method: 'GET',
					path: '/admin/users/{userId}/settings/substitution',
					pathParams: ['userId'] as const,
					queryKey: (args) =>
						getUsersSettingsSubstitutionLoadQueryKey(args?.pathParams?.userId),
					queryOptions: (args) =>
						getUsersSettingsSubstitutionLoadQueryOptions(
							args?.pathParams?.userId,
						),
				}),
				reset: defineMutationEndpoint<
					SubstitutionSettingsDto,
					undefined,
					{ userId: number }
				>({
					key: 'users.settings.substitution.reset',
					method: 'DELETE',
					path: '/admin/users/{userId}/settings/substitution',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
						}) => usersSettingsSubstitutionReset(variables.userId),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsSubstitutionLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
				update: defineMutationEndpoint<
					SubstitutionSettingsDto,
					CreateOrUpdateSubstitutionSettingsRequest,
					{ userId: number }
				>({
					key: 'users.settings.substitution.update',
					method: 'PUT',
					path: '/admin/users/{userId}/settings/substitution',
					pathParams: ['userId'] as const,
					mutationOptions: () => ({
						mutationFn: (variables: {
							userId: number | string | null | undefined
							data: CreateOrUpdateSubstitutionSettingsRequest
						}) =>
							usersSettingsSubstitutionUpdate(variables.userId, variables.data),
					}),
					invalidates: [
						(context) =>
							getUsersSettingsSubstitutionLoadQueryKey(
								context.entityId ?? context.ownerId,
							),
						(_context) => getUsersListQueryKey(),
						(context) =>
							getUsersDetailQueryKey(context.entityId ?? context.ownerId),
					],
				}),
			},
		},
	},
} as const
// #endregion

// #region Client Endpoints
const usersClientEndpoints = {
	getCustompages: defineQueryEndpoint<CustomPageDto, undefined, undefined>({
		key: 'users.client.getCustompages',
		method: 'GET',
		path: '/api/users/custompages',
		queryKey: (_args) => getUsersClientGetCustompagesQueryKey(),
		queryOptions: (_args) => getUsersClientGetCustompagesQueryOptions(),
	}),
} as const
// #endregion

// #region Entity Config Export
export const usersEntityConfig = {
	key: 'users',
	kind: 'entity',
	entity: {
		idField: 'id',
		idParam: 'userId',
		routePath: '/users',
	},
	endpoints: usersEntityEndpoints,
	relations: {
		customPages: usersCustomPagesRelation,
		pauseReasons: usersPauseReasonsRelation,
		queues: usersQueuesRelation,
		roles: usersRolesRelation,
		skillGroups: usersSkillGroupsRelation,
		skills: usersSkillsRelation,
		teams: usersTeamsRelation,
		templates: usersTemplatesRelation,
	},
	settings: usersSettings,
	client: usersClientEndpoints,
} as const satisfies EntityConfig<'users'>
// #endregion
